/* Esta vista recoge los elementos de la carpeta componentes/fuentesDeDescarga y les asigna el evento de clic del botón de ejecución, así 
como los métodos para la selección del label de status de cada fuente de descarga, selección del icono o selección del color de los botones
de status en el panel de cards y en la tabla de resumen. Todos son enviados a los componentes child a través de las props.

Existe una interacción compleja con redux para la funcionalidad que cambia el modo de visualización desde uno de los iconos del navbar. El
método changeVisualizationIconOnNavbar interactúa con el storage de redux, el cual, a su vez, ocasiona un nuevo renderizado del navbar.
Dicho método hace un dispatch enviando, en un array, todos los elementos que deberían ser pintados en el navbar y, a su vez, cambia el state
del componente FuentesDeDescarga, tal que se ajusta la variable de visualización. Así, cada vez que se hace clic en el botón, se envían nuevos
botones al navbar ocasionando un nuevo renderizado y, además, se renderiza el componente FuentesDeDescarga teniendo en cuenta la visualización
target escogida por el usuario */

import React from "react";
import Swal from "sweetalert2";
import { connect } from "react-redux";

//Componentes auxiliares:
import HelpButton from "../layouts/mainLayout/components/HelpButton";
import FlagButton from "../components/downloadSourcesResume/auxiliars/FlagButton";
import RealtimeSynchronizer from "../components/downloadSourcesResume/auxiliars/RealtimeSynchronizer";
import DownloadSourcesResumePanel from "../components/downloadSourcesResume/DownloadSourcesResumePanel";
import DownloadSourcesResumeTable from "../components/downloadSourcesResume/DownloadSourcesResumeTable";
import VisualizationModeChangeButton from "../components/downloadSourcesResume/auxiliars/VisualizationModeChangeButton";

//Scripts auxiliares:
import { getCronNextDates } from "../tools/scripts/cronUtils";
import { forceUserLogout } from "../tools/scripts/userRelated";
import {
  timeoutPromise,
  registerAuditProcess,
} from "../tools/scripts/customFetching";

import {
  getSwalContentForScratchRequest,
  getSwalContentForRetryRequest,
  getSwalContentForCancelRequest,
  retryDownloadProcess,
  cancelDownloadProcess,
} from "./common/downloadSourcesOperations";

import {
  getStatusButtonClassname,
  getStatusIconClassname,
  getDownloadSourceTitle,
  getTimelineDivClassname,
  getTimelineIconClassname,
  getScratchUrl,
} from "./common/downloadSourcesRenderingFunctions";

//Contenido del tour de ayuda:
import { downloadSourcesResumeTourConfig } from "./tours/DownloadSourcesResume";

class DownloadSourcesResume extends React.Component {
  //Métodos de ciclo de vida del componente:
  constructor() {
    super();

    this.state = {
      viewAsCards: true,
      downloadSources: [],
    };
  }

  componentDidMount() {
    let visualizationModeFromLS = JSON.parse(
      localStorage.getItem("downloadSourcesResume.visualizationMode")
    );
    if (visualizationModeFromLS !== null) {
      switch (visualizationModeFromLS) {
        case "table":
          this.setState({ viewAsCards: false });
          break;

        case "cards":
          this.setState({ viewAsCards: true });
          break;

        default:
          break;
      }
    }

    this.getDownloadSourcesFromBackend();
    this.changeVisualizationIconOnNavbar();
  }

  render() {
    return (
      <div className="content">
        {this.getContentBasedOnVisualizationMode()}
        <RealtimeSynchronizer
          downloadSources={this.state.downloadSources}
          functionToBeExecuted={this.getDownloadSourcesFromBackend}
        />
      </div>
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.viewAsCards !== this.state.viewAsCards) {
      this.changeVisualizationIconOnNavbar();
    }
  }

  //Métodos operativos:
  retryDownloadProcess = (targetProcess, downloadSource) => {
    let swalContent = getSwalContentForRetryRequest(downloadSource);

    Swal.fire(swalContent).then((result) => {
      if (result.value) {
        retryDownloadProcess(
          this.props,
          targetProcess,
          downloadSource,
          registerAuditProcess,
          () => {
            this.getDownloadSourcesFromBackend(false);
          }
        );
      }
    });
  };

  cancelDownloadProcess = (targetProcess, downloadSource) => {
    let swalContent = getSwalContentForCancelRequest(downloadSource);

    Swal.fire(swalContent).then((result) => {
      if (result.value) {
        cancelDownloadProcess(
          this.props,
          targetProcess,
          downloadSource,
          registerAuditProcess,
          () => {
            this.getDownloadSourcesFromBackend(false);
          }
        );
      }
    });
  };

  executeScratchOnClick = (e, downloadSource) => {
    this.instanciateScratchRequest(downloadSource, true);
  };

  saveInteractiveActionOnClick = (e, downloadSource, actionDetails) => {
    this.saveInteractiveAction(downloadSource, actionDetails, true);
  };

  saveInteractiveAction = (downloadSource, actionDetails, forceUpdate) => {
    console.log("saveInteractiveAction", downloadSource);
    let executeScratchEndpoint =
      process.env.REACT_APP_API_URL +
      "/processes/" +
      downloadSource.source_process?.[0].id +
      "/save_interactive_action/";
    let body = actionDetails;
    fetch(executeScratchEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + this.props.activeUser.authToken,
      },
      body: JSON.stringify(body),
    })
      .then((serverResponse) => {
        switch (serverResponse.status) {
          case 200:
          case 201:
            serverResponse.json().then((serverResponse) => {
              Swal.fire(
                "",
                "Su seleccion fue guardada con éxito</b>",
                "success"
              );

              registerAuditProcess(this.props, {
                event_type: "INTERACTION_ACTION_EXECUTED",
                description:
                  "El usuario guardo los datos <b>" +
                  //   targetProcess.description.replace(":", ": ") +
                  "</b>",
              });

              if (forceUpdate) {
                timeoutPromise().then(() => {
                  this.getDownloadSourcesFromBackend(false, forceUpdate);
                });
              } else {
                this.getDownloadSourcesFromBackend(false, forceUpdate);
              }
            });
            break;
          case 401:
            forceUserLogout();
            break;
          case 203:
            Swal.fire(
              "",
              "El proceso guardar los datos no puede ser ejecutado en su estado actual. Error: " +
                JSON.stringify(serverResponse.status),
              "error"
            );
            break;
          default:
            Swal.fire(
              "",
              "El proceso guardar los datos no pudo iniciarse. Error: " +
                JSON.stringify(serverResponse.status),
              "error"
            );
            break;
        }
      })
      .catch((err) => {
        console.log(err);
        Swal.fire(
          "",
          "El proceso guardar los datos no pudo iniciarse " + err.message,
          "error"
        );
      });
  };

  formatSourcesList = (originalSources) => {
    let formattedSources = originalSources.map((source, i) => {
      let nextDate = null;

      try {
        let cronObject = { ...source.task_programming.crontab_schedule };
        let expirationDate = source.task_programming.periodic_task.expires;
        // Honor the PeriodicTask.start_time stored by django-celery-beat so
        // scheduled sources whose first run is days in the future show the
        // correct upcoming date in the card, not tomorrow.
        let startTime = source.task_programming.periodic_task.start_time;
        let startTimeObj = startTime ? new Date(startTime) : null;
        // Use start_time as the cron anchor only if it's in the future;
        // once the bot has started its recurring schedule, calculating
        // "next run" from "now" is correct.
        let effectiveAnchor = null;
        if (startTimeObj && startTimeObj > new Date()) {
          effectiveAnchor = startTimeObj;
        }
        let nextDates = getCronNextDates(cronObject, 1, expirationDate, effectiveAnchor);

        try {
          nextDate = nextDates[0];
          if (nextDate <= new Date()) {
            nextDate = null;
          }
        } catch (error) {}
      } catch (error) {}

      return { ...source, next_execution_date: nextDate };
    });

    formattedSources = formattedSources.filter(
      (item) => item.country_scope === this.props.activeUser.country_scope
    );
    formattedSources = formattedSources.map((source, i) => {
      return { ...source, index: formattedSources.length - i };
    });

    return formattedSources;
  };

  getDownloadSourcesFromBackend = (changeCursor = true) => {
    if (changeCursor) {
      window.document.body.style.cursor = "wait";
    }

    //console.log(`download source ${process.env.REACT_APP_API_URL}`)
    fetch(process.env.REACT_APP_API_URL + "/sources/", {
      method: "get",
      headers: { Authorization: "Token " + this.props.activeUser.authToken },
    })
      .then((serverResponse) => {
        switch (serverResponse.status) {
          case 200:
            serverResponse.json().then((sources) => {
              this.updateActiveDownloadSources(sources);
              if (changeCursor) {
                window.document.body.style.cursor = "default";
              }
            });
            break;

          case 401:
            forceUserLogout();
            break;

          default:
            window.document.body.style.cursor = "default";
            break;
        }
      })
      .catch((error) => {
        console.log(error);
        if (changeCursor) {
          window.document.body.style.cursor = "default";
        }
      });
  };

  instanciateScratchRequest = (downloadSource, forceUpdate = false) => {
    let swalContent = getSwalContentForScratchRequest(downloadSource);

    if (this.props.activeUser.is_admin || this.props.activeUser.is_staff) {
      Swal.fire(swalContent).then((result) => {
        if (result.value) {
          let executeScratchEndpoint =
            process.env.REACT_APP_API_URL +
            "/sources/" +
            downloadSource.id +
            "/execute_pipeline_scratch/";
          let body =
            typeof result.value == "boolean" ? {} : { variables: result.value };
          fetch(executeScratchEndpoint, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Token " + this.props.activeUser.authToken,
            },
            body: JSON.stringify(body),
          })
            .then((serverResponse) => {
              switch (serverResponse.status) {
                case 200:
                case 201:
                  serverResponse.json().then((serverResponse) => {
                    Swal.fire(
                      "",
                      "El proceso de descarga <b>se ha añadido a la cola de procesos con éxito</b>",
                      "success"
                    );

                    registerAuditProcess(this.props, {
                      event_type: "SCRATCH_EXECUTED",
                      description:
                        "El usuario ejecutó la descarga <b>" +
                        downloadSource.description.replace(":", ": ") +
                        "</b>",
                    });

                    if (forceUpdate) {
                      timeoutPromise().then(() => {
                        this.getDownloadSourcesFromBackend(false, forceUpdate);
                      });
                    } else {
                      this.getDownloadSourcesFromBackend(false, forceUpdate);
                    }
                  });
                  break;

                case 401:
                  forceUserLogout();
                  break;
                case 203:
                  Swal.fire(
                    "",
                    "El proceso de descarga no puede ser ejecutado en su estado actual. Error: " +
                      JSON.stringify(serverResponse.status),
                    "error"
                  );
                  break;
                default:
                  Swal.fire(
                    "",
                    "El proceso de descarga no pudo iniciarse. Error: " +
                      JSON.stringify(serverResponse.status),
                    "error"
                  );
                  break;
              }
            })
            .catch((err) => {
              console.log(err);
              Swal.fire(
                "",
                "El proceso de descarga no pudo iniciarse " + err.message,
                "error"
              );
            });
        }
      });
    }
  };

  updateActiveDownloadSources = (downloadSources, forceUpdate = false) => {
    let showUpdateMessage = false;

    if (downloadSources.length === this.state.downloadSources.length) {
      let sortedNewDownloadSources = downloadSources.sort((a, b) =>
        a.id > b.id ? 1 : b.id > a.id ? -1 : 0
      );
      let sortedActiveDownloadSources = this.state.downloadSources.sort(
        (a, b) => (a.id > b.id ? 1 : b.id > a.id ? -1 : 0)
      );

      if (
        JSON.stringify(sortedNewDownloadSources) !==
          JSON.stringify(sortedActiveDownloadSources) ||
        forceUpdate
      ) {
        if (showUpdateMessage) console.log("Debo actualizar los sources");
        this.setState({
          downloadSources: this.formatSourcesList(downloadSources),
        });
      } else {
        if (showUpdateMessage) console.log(sortedNewDownloadSources);
        if (showUpdateMessage) console.log("No debo actualizar los sources");
      }
    } else {
      if (showUpdateMessage) console.log("Debo actualizar los sources");
      this.setState({
        downloadSources: this.formatSourcesList(downloadSources),
      });
    }
  };

  //Métodos de renderizado:
  changeActiveVisualizationMode = () => {
    localStorage.setItem(
      "downloadSourcesResume.visualizationMode",
      JSON.stringify(!this.state.viewAsCards ? "cards" : "table")
    );
    this.setState({ viewAsCards: !this.state.viewAsCards });
  };

  changeVisualizationIconOnNavbar = () => {
    let iconoTarget = !this.state.viewAsCards ? "IoIosApps" : "FaTable";

    this.props.changeRelatedNavbarButtons([
      <FlagButton countryScope={this.props.activeUser.country_scope} />,

      <VisualizationModeChangeButton
        icono={iconoTarget}
        onClick={this.changeActiveVisualizationMode}
      />,

      <HelpButton tourContent={downloadSourcesResumeTourConfig} />,
    ]);
  };

  getContentBasedOnVisualizationMode = () => {
    if (this.state.viewAsCards) {
      return this.getPanelWithDownloadSources(this.state.downloadSources);
    } else {
      return this.getTableWithDownloadSources(this.state.downloadSources);
    }
  };

  getPanelWithDownloadSources = (downloadSources) => {
    return (
      <DownloadSourcesResumePanel
        downloadSources={downloadSources}
        cancelDownloadProcess={this.cancelDownloadProcess}
        retryDownloadProcess={this.retryDownloadProcess}
        executeScratchOnClick={this.executeScratchOnClick}
        saveInteractiveActionOnClick={this.saveInteractiveActionOnClick}
        getScratchUrl={getScratchUrl}
        getStatusButtonClassname={getStatusButtonClassname}
        getStatusIconClassname={getStatusIconClassname}
        getDownloadSourceTitle={getDownloadSourceTitle}
        getTimelineDivClassname={getTimelineDivClassname}
        getTimelineIconClassname={getTimelineIconClassname}
        reloadSourcesMethod={this.getDownloadSourcesFromBackend}
      />
    );
  };

  getTableWithDownloadSources = (downloadSources) => {
    return (
      <DownloadSourcesResumeTable
        downloadSources={downloadSources}
        cancelDownloadProcess={this.cancelDownloadProcess}
        retryDownloadProcess={this.retryDownloadProcess}
        executeScratchOnClick={this.executeScratchOnClick}
        getScratchUrl={getScratchUrl}
        getStatusButtonClassname={getStatusButtonClassname}
        getStatusIconClassname={getStatusIconClassname}
        getDownloadSourceTitle={getDownloadSourceTitle}
        getTimelineDivClassname={getTimelineDivClassname}
        getTimelineIconClassname={getTimelineIconClassname}
        reloadSourcesMethod={this.getDownloadSourcesFromBackend}
      />
    );
  };
}

const mapdispatchToProps = (dispatch) => {
  return {
    changeRelatedNavbarButtons: (navbarButtons) =>
      dispatch({ type: "changeNavbarButtons", navbarButtons: navbarButtons }),
  };
};

const mapStateToProps = (state) => {
  return {
    activeUser: state.mainReducer.activeUser,
    coreBackendHost: state.mainReducer.coreBackendHost,
    enableAuditRegistering: state.mainReducer.enableAuditRegistering,
  };
};

export default connect(
  mapStateToProps,
  mapdispatchToProps
)(DownloadSourcesResume);
